import { Link } from "@/i18n/navigation";

export default function NewLinkNave({
    children,
    href,
    page,
    name,
    currentSVG,
    notCurrentSVG,
    blank = false,
    sideNavIsOpen: setSideNavIsOpen = () => {},
    compact = false,
    label,
}) {
    const handleClick = () => {
        if (setSideNavIsOpen) {
            setSideNavIsOpen(false);
        }
    };

    const isActive = page == name;

    if (compact) {
        return (
            <div className="relative group">
                <Link
                    href={href}
                    className={`sidenav-link sidenav-link-compact ${
                        isActive
                            ? "font-semibold !text-[#05060F] dark:!text-lightBlue bg-black/[0.08] dark:bg-white/[0.10]"
                            : ""
                    }`}
                    target={blank ? "_blank" : "_self"}
                    onClick={handleClick}
                    aria-label={label}
                >
                    {currentSVG && notCurrentSVG && (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-5 h-5"
                            viewBox="0 0 24 24"
                        >
                            {isActive ? currentSVG : notCurrentSVG}
                        </svg>
                    )}
                </Link>
                {label && (
                    <span
                        role="tooltip"
                        className="pointer-events-none absolute left-full top-1/2 -translate-y-1/2 ml-2 px-2 py-1 rounded-md bg-gray-900 dark:bg-bgDark-300 text-white text-xs font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-150 z-50 shadow-lg"
                    >
                        {label}
                    </span>
                )}
            </div>
        );
    }

    return (
        <Link
            href={href}
            className={`sidenav-link ${
                isActive
                    ? "font-semibold !text-[#05060F] dark:!text-lightBlue bg-black/[0.08] dark:bg-white/[0.10]"
                    : ""
            }`}
            target={blank ? "_blank" : "_self"}
            onClick={handleClick}
        >
            {currentSVG && notCurrentSVG && (
                <>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-5 h-5"
                        viewBox="0 0 24 24"
                    >
                        {isActive ? currentSVG : notCurrentSVG}{" "}
                    </svg>
                </>
            )}
            {children}
        </Link>
    );
}
